// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"670f54a6","232":"5ba8fc6a","237":"4e358db9","526":"2b7eac15","787":"9c643572","872":"abefab79"}[chunkId] + ".chunk.js";
};